import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { translations, getByPath } from "../i18n";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("totumo-lang") || "en");

  useEffect(() => {
    localStorage.setItem("totumo-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback(
    (key) => {
      const val = getByPath(translations[lang], key);
      if (val !== undefined) return val;
      return getByPath(translations.en, key) ?? key;
    },
    [lang]
  );

  const toggle = () => setLang((l) => (l === "en" ? "es" : "en"));

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
